import { CAR_DEFAULT_IMG } from '@components/MainWidget/common/widgetImagesConstant'

export const getVehicleVariantImage = (vehicleImage: any) =>
  vehicleImage?.image || vehicleImage?.logo_url || CAR_DEFAULT_IMG

export const getDaysUntilPolicyExpiry = (data: { previous_policy_expiry_detail: string }): number => {
  if (data?.previous_policy_expiry_detail) {
    const expiryDate = new Date(data.previous_policy_expiry_detail)
    const currentDate = new Date()

    const differenceInTime = expiryDate.getTime() - currentDate.getTime()
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24))

    return differenceInDays
  }

  return 0
}

export const redirectToAutoPayment = async (path: string, regNo: string, phone: string) => {
  try {
    const response = await fetch(`${path}?registration_number=${regNo}&phone=${phone}`)

    if (!response.ok) {
      throw new Error('Failed to fetch redirect URL')
    }

    const data = await response.json()
    const redirectUrl = data?.redirect_url

    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      console.error('No redirect URL returned from API')
    }
  } catch (error) {
    console.error('Redirection failed:', error)
  }
}
